<template lang="pug">
  FormModal(title="Edit Featured Image", :endpoint="endpoint", :data="data", v-bind="$attrs", @success="success")
    InputGroup(label="", name="featured_image")
      ImageInput(v-model="data.featured_image")
</template>

<script>
import { EditModalMixin } from "@syntax51/app-kit"

export default {
  mixins: [EditModalMixin],
  data: () => ({
    data: {
      featured_image: null
    }
  }),
  methods: {
    success(result) {
      this.$notification.success(`Updated featured image.`)
      this.$emit("close", result)
    }
  }
}
</script>
